/**
 * Session related apis
 */

import axios from 'axios';

import { getRequestConfig } from './config';
import Vue from 'vue';

import { 
  OK
} from './ajaxActionResponse';
import { 
 REQUEST_WATCHLIST_ACTION, SAVE_WATCHLIST_ACTION,  LOGIN_ACTION, LOGOUT_ACTION, 
 REQUEST_ININITIAL_MESSAGE, PING_ACTION, SAVE_STATE_ACTION, IMPERSONATE_ACTION,
 REVERT_TO_SELF_ACTION,INVITE_PATIENT_ACTION,UNINVITE_PATIENT_ACTION, SHARE_ACQUIRE_ACTION,
 SHARE_SUMMARY_ACTION
} from './ajaxActions';
import { request,inRequest } from './request';

export function requestVitalSignsCodes() {
  const config = getRequestConfig(null, 'requestVitalSignsCodes', '/session/requestVitalSignsCodes');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data.codes);
      } else {
        reject('Unable to retrieve vital sign codes');
      }
    })
  });
}

export function getAllData() {
  const config = getRequestConfig(null, 'getAllData');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      const { data } = response;
      if (data) {
        resolve(data);
      } else {
        reject('Unable to retrieve application data');
      }
    })
  });
}

/**
 * Pings server to check session status 
 */
export function ping() {
  if(inRequest()) {
    // no op
    let p = new Promise((resolve) => {
      resolve();
    });
    return p;
  }
  const config = getRequestConfig(null, PING_ACTION, '/session/ping');

  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => {
        if (response.data.status === OK) {
          resolve();
        } else {
          reject('Ping: Session timed out');
        }
      })
  });
};

export function summaryByExternalId(id) {
  let payload = { externalId: id };
  const config = getRequestConfig(payload,SHARE_SUMMARY_ACTION,'/session/summaryByExternalId');
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve(response.data);
        else
          reject('Unable to get patient data')
      })
      .catch((err)=>{
        reject(`Unable to get patient data: ${err}`)
      })
  });
};

export function acquireByExternalId(id) {
  let payload = { externalId: id };
  const config = getRequestConfig(payload,SHARE_ACQUIRE_ACTION,'/session/acquireByExternalId');
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve(response.data);
        else
          reject('Unable to share patient')
      })
      .catch((err)=>{
        reject(`Unable to share patient: ${err}`)
      })
  });
};

export function invitePatient() {
  let payload = {};
  const config = getRequestConfig(payload,INVITE_PATIENT_ACTION,'/session/invitePatient');
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve();
        else
          reject('unable to invite patient')
      })
      .catch((err)=>{
        reject(`unable to invite patient: ${err}`)
      })
  });
};

export function uninvitePatient() {
  let payload = {};
  const config = getRequestConfig(payload,UNINVITE_PATIENT_ACTION,'/session/uninvitePatient');
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve();
        else
          reject('unable to uninvite patient')
      })
      .catch((err)=>{
        reject(`unable to uninvite patient: ${err}`)
      })
  });
};

export function revertToSelf() {
  let payload = {};
  const config = getRequestConfig(payload,REVERT_TO_SELF_ACTION,'/session/revertToSelf');
  // console.log(config.url)
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve();
        else
          reject('unable to revert to self')
      })
      .catch((err)=>{
        reject(`unable to revert to self: ${err}`)
      })
  });
};
export function impersonate(id) {
  let payload = {
    id
  };
  const config = getRequestConfig(payload, IMPERSONATE_ACTION, '/session/impersonate');
  return new Promise((resolve,reject)=> {
    request(config)
      .then((response)=>{
        if(response.data.status === OK)
          resolve();
        else
          reject('unable to impersonate')
      })
      .catch((err)=>{
        reject(`unable to impersonate: ${err}`)
      })
  });
};
export let saveState = (text) => {
  let payload = {
    text
  };
  const config = getRequestConfig(payload, SAVE_STATE_ACTION, '/session/saveState');
  return new Promise((resolve, reject) =>{
    request(config)
      .then((response) => {
        if (response.data.status === OK)
            resolve();
        else 
          reject(`unable to get inital message: ${err}`);
      })
      .catch((err) => {
        reject(`unable to get inital message: ${err}`);
      })
    });
};

export let saveWatchList = async (text) => {
  let payload = {
    text
  };
  const config = getRequestConfig(payload, SAVE_WATCHLIST_ACTION, '/session/saveWatchList');

  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => {
        if (response.data.status === OK)
            resolve();
        else 
          reject(`unable to save watchlist: ${err}`);
      })
      .catch((err) => {
        reject(`unable to save watchlist: ${err}`);
      })
    });
};

export function login(loginForm) {
  const config = getRequestConfig(loginForm, LOGIN_ACTION, '/session/login');

  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export async function logout() {
  const config = getRequestConfig(null, LOGOUT_ACTION, '/session/logout');
  return new Promise((resolve, reject) => {
    axios.request(config)
    .then((response) => {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    })
  });
};

export const getWatchList = async () => {
  const config = getRequestConfig(null, REQUEST_WATCHLIST_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  })
};
export const getInitialMessage = async () => {
  const config = getRequestConfig({ action: 'requestInitialMessage' }, REQUEST_ININITIAL_MESSAGE, '/session/requestInitialMessage');
  return new Promise((resolve, reject) => {
    store.dispatch('login/updateCsrf',null);
    request(config)
    .then((response) => {
      Vue.gotInitialMessage = true;
      resolve(response.data.data);
    })
    .catch((err) => {
      Vue.gotInitialMessage = true;
      reject(err);
    });
  });  
};
